import { render, staticRenderFns } from "./ShopLayout.vue?vue&type=template&id=5f5f618c&scoped=true"
import script from "./ShopLayout.vue?vue&type=script&lang=js"
export * from "./ShopLayout.vue?vue&type=script&lang=js"
import style0 from "./ShopLayout.vue?vue&type=style&index=0&id=5f5f618c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.39_css-loader@6.11.0_webpack@5.108.4_cssnano@5_9449f7de44cb275de9d2805a6df01d68/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f618c",
  null
  
)

export default component.exports